import { render } from "./UserAddress.vue?vue&type=template&id=4a8c1508&scoped=true&ts=true"
import script from "./UserAddress.vue?vue&type=script&lang=ts"
export * from "./UserAddress.vue?vue&type=script&lang=ts"

import "./UserAddress.vue?vue&type=style&index=0&id=4a8c1508&scoped=true&lang=css"

import exportComponent from "C:\\Projects\\eFJ\\eFjApp\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a8c1508"]])

export default __exports__